
import sortOptions from "@/plugins/mixins/sort-options";
import stickyResultsOffset from "@/plugins/mixins/sticky-results-offset";

export default {
	mixins: [sortOptions, stickyResultsOffset],
	props: {
		count: {
			type: Number,
			required: true,
		},
		tableFields: {
			type: Array,
			required: true,
		},
		currentSort: {
			type: String,
			required: true,
		},
		dictionary: {
			type: Object,
			required: true,
		},
		usePillsLayout: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		isAnagramResultsPage() {
			return this.$store.getters["navigation/isAnagramResultsPage"];
		},
		isScrabbleResultsPage() {
			return this.$store.getters[
				"navigation/isScrabbleDictionaryResultsPage"
			];
		},
		summary() {
			if (
				this.$store.getters["navigation/isWordleResultsPage"] ||
				this.$store.getters["navigation/isQuordleResultsPage"]
			) {
				if (this.isSmallDevice) {
					return this.$store.getters["navigation/isWordleResultsPage"]
						? "Wordle Solver"
						: "Quordle Solver";
				}
				return "Words";
			}
			const dictionaryLabel = this.$t(this.dictionary.text);
			const stubs = this.isMediumDeviceOrWider
				? [
						this.count,
						dictionaryLabel,
						this.count === 1 ? "word" : "words",
				  ]
				: [dictionaryLabel];

			return stubs.join(" ");
		},
	},
	methods: {
		onDropdownSelect(value) {
			this.$emit("change", value);
		},
	},
};
